"use strict";

exports.__esModule = true;
exports.random = random;
function random(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}


//////////////////
// WEBPACK FOOTER
// ../src/js/util.js
// module id = 2
// module chunks = 0